<div class="square-img" [style.width.px]="width">
  <div *ngIf="photo != null || url != null" class="rounded-circle" [style.background-image]="getBackgroundImage()" [ngStyle]="{ 'background-color': backgroundWhite ? '#fff' : '' }"></div>
  <div *ngIf="photo == null && url == null" class="rounded-circle" [ngStyle]="{ 'background-color': backgroundWhite ? '#fff' : '' }">
    <span class="initials cursor-default">{{ initials }}</span>
  </div>
</div>
